import React from "react";
import MainLayout from "./components/Layouts/Mainlayout";
import { Outlet } from "react-router-dom";

export default function AppLayout() : JSX.Element{
  return (
     <div className="flex flex-row justify-start">
    <MainLayout>
      <Outlet />
    </MainLayout>
    </div>
  );
}
